export default "__VITE_ASSET__Cp8Jh31x__"